export type CoverageAreaDialogMessages = {
  deleteTitle: string;
  deleteContent: string;
  deleteCancel: string;
  deleteConfirm: string;
  deleteSuccess: string;
  deleteError: string;
};

export const COVERAGE_AREA_DIALOG_MESSAGES: CoverageAreaDialogMessages = {
  deleteTitle: "Excluir Área de Abrangência",
  deleteContent: "Tem certeza de que deseja excluir esta área de abrangência?",
  deleteCancel: "Cancelar",
  deleteConfirm: "Confirmar",
  deleteSuccess: "Área de Abrangência excluída com sucesso.",
  deleteError: "Erro ao excluir a Área de Abrangência.",
};
// no default export
